export enum AuthorizationReason{
    Unknown = 0,
    Login = 1,
    Withdraw = 2,
    ChangeAdress = 3,
    ChangePhonenumber = 4,
    ChangePersonalData = 5,
    ChangePassword = 6,
    GenerateSeed = 7,
    RequestForgotPassword = 8,
    ForgotPassword = 9,
    Monthly = 10,
    Permanent = 11,
    RequestUnlock = 12,
    Push = 13,
    AddBankAccount = 14,
    DeleteBankAccount = 15,
    ChangeToZeroBrokerage = 16,
    ChangeLimitRisk = 17,
    CancelPackage = 18,
    SubmitPackage = 19,
    ChangeIncome = 20,
    ChangeName = 21,
    ChangeBusinessAddress = 22,
    ChangeDataBusiness = 23,
    ChangeBusinessIncomeDequity = 24,
    ChangeSocietalStruture = 25,
    ChangeEmail = 26,
    UnlockAccount = 27
}